/* import __COLOCATED_TEMPLATE__ from './external-conversation-adapter.hbs'; */
/* eslint-disable ember/no-empty-glimmer-component-classes */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';

import type Conversation from 'embercom/objects/inbox/conversation';

interface Args {
  conversation: Conversation;
  externalId: string;
  externalType: string;
}

export default class ExternalConversationAdapter extends Component<Args> {
  // Likely will need iframe communication here
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Adapters::ExternalConversationAdapter': typeof ExternalConversationAdapter;
  }
}
